const studyDirections = [
    {
      name: "Society and Social Affairs",
      subDirections: [
        "Educational sciences and teaching profession",
        "Peace and conflict research",
        "Political Science",
        "Psychology",
        "Religious studies and philosophy",
        "Social work, social services",
        "Social work and social welfare",
        "Social sciences",
        "Urban and regional planning, transportation",
        "Theology"
      ]
    },
    {
      name: "Engineering",
      subDirections: [
        "Automation technology",
        "Civil Engineering",
        "Biotechnology and Bioengineering",
        "Chemical engineering and process engineering",
        "Printing technology",
        "Electrical engineering",
        "Automotive and traffic engineering",
        "Precision engineering and microtechnology",
        "Engineering sciences",
        "Food technology and food chemistry",
        "Aerospace engineering",
        "Mechanical Engineering",
        "Mechatronics",
        "Media and information technology",
        "Medical technology",
        "Optical technologies",
        "Seafaring & marine engineering",
        "Engineering",
        "Technical environmental protection",
        "Textile and clothing technology",
        "Surveying",
        "Supply engineering",
        "Materials science",
        "Industrial Engineering and Management"
      ]
    },
    {
      name: "Art, music and design",
      subDirections: [
        "Architecture",
        "Design and creation",
        "Interior design",
        "Art (applied / free)",
        "Music",
        "Theater, film and directing"
      ]
    },
    {
      name: "People, medicine and healthcare",
      subDirections: [
        "Nutritional sciences",
        "Public Health",
        "Medicine",
        "Nursing Sciences",
        "Pharmacy",
        "Sports",
        "Therapies",
        "Veterinary Medicine",
        "Dentistry"
      ]
    },
    {
      name: "Nature and the environment",
      subDirections: [
        "Agricultural sciences",
        "Forestry",
        "Horticulture and landscape conservation",
        "Wood",
        "Environmental sciences"
      ]
    },
    {
      name: "Natural sciences and mathematics",
      subDirections: [
        "Biology",
        "Chemistry",
        "Geography",
        "Geosciences",
        "Computer Science",
        "Mathematics",
        "Physics",
        "Statistics"
      ]
    },
    {
      name: "Law and economics",
      subDirections: [
        "Business Administration",
        "International Business",
        "Logistics and Transportation",
        "Management Sciences",
        "Law",
        "Political Science",
        "Tourism and event management",
        "Administration",
        "Economics",
        "Business Informatics",
        "Business Law"
      ]
    },
    {
      name: "Language and culture",
      subDirections: [
        "Ancient languages and cultures",
        "Archaeology",
        "Library and information science",
        "Ethnology",
        "Historical Sciences",
        "Journalism and publicity studies",
        "Cultural studies",
        "Arts and Humanities",
        "Literary Studies",
        "Media Studies",
        "Modern Languages and Cultures",
        "Musicology",
        "Linguistics",
        "Translating"
      ]
    }
  ];
  
  export default studyDirections;  